import * as React from 'react';

interface LazyLoadProps {
  asyncImport: () => Promise<any>;
  childProps: any;
}

interface LazyLoadState {
  Component: any;
}

export class LazyLoad extends React.Component<LazyLoadProps, LazyLoadState> {
  constructor(props) {
    super(props);

    this.state = {
      Component: null,
    };
  }

  componentDidMount() {
    this.props.asyncImport().then(module => {
      this.setState({
        Component: module.default || module,
      });
    });
  }

  render() {
    const { Component } = this.state;
    return Component === null ? (
      <div>Loading...</div>
    ) : (
      <Component {...this.props.childProps} />
    );
  }
}

/**
 * Helper function that can be passed directly into react-router's <Route /> component
 * @param asyncImport Import call of module
 *
 * Example: <Route component={lazyLoadRoute(() => import('views'))} />
 */
export const lazyLoadRoute = (asyncImport: () => Promise<any>) => (
  props: any
) => <LazyLoad asyncImport={asyncImport} childProps={props} />;
